/* istanbul ignore file */

/**
 * String file for US English (en_us).
 *
 * key1: 'value of key1 in en',
 * interpolation: (what: string, how: string) => `${what} is ${how}`,
 * dateFormat: (date: Date) => `The current date is ${formatDate(date, 'MM/DD/YYYY')}`,
 * keyWithCount: (count: number) => `${count} item${count === 1 ? '' : 's'}`
 */
export default {
  crypto: {
    CryptoNotAvailable: 'crypto module could not be loaded from environment',
    CryptoNotAvailableUsingMath: 'crypto module not available, using Math.random'
  },
  langcult: 'en_us',
  language_name: 'US English',
  error: {
    actions: {
      noActionHintsError: 'Error, no action hints were available'
    },
    board: {
      cannotPlayAction: (action: string, state: string) => `Cannot do action ${action}, board is at ${state}.`
    },
    table: {
      playStartError: (state: string) => `Cannot start table play, table is ${state}.`,
      playOutOfOrder: (player: string) => `Cannot play out of order, it is not ${player}'s turn.`,
      cantCallNoBet: 'Player cannot call, there are no bets.',
      cantBetLessThanMax: 'Player cannot bet less than max bet.',
      cantRaiseLessThanMax: 'Player cannot raise less than max bet.',
      cannotStackPotsBeforeShowdown: 'Cannot stack the pot before showdown.',
      triedToPlayBlindsOutOfOrderError: 'Blinds can only be paid before cards are dealt.',
      betUndefinedForPlayer: 'Bet was not defined when player tried to doBetForPlayer'
    }
  },
  states: {
    board: {
      predeal: 'Before Deal',
      deal: 'Deal',
      flop: 'Flop',
      turn: 'Turn',
      river: 'River',
      showdown: 'Showdown'
    },
    game: {
      pregame: 'Game created',
      readytoplay: 'Game is ready to play',
      playing: 'Game in play',
      sleep: 'Game is sleeping',
      reset: 'Game is reset',
      paused: 'Game is paused',
      finished: 'Game is finished',
      default: 'Default',
      tournament: 'Tournament',
      practice: 'Practice',
      open: 'Open',
      threeCard: 'Three Card'
    },
    player: {
      waiting: 'Waiting',
      inplay: 'In Play',
      folded: 'Folded',
      allin: 'All in',
      out: 'Out',
      sitOut: 'Sit Out',
      foreverOut: 'Forever Out',
      disconnected: 'Disconnected',
      observer: 'Observer'
    }
  },
  betHints: {
    multipleOfBet: {
      twoTimes: '2X Bet',
      threeTimes: '3X Bet',
      fourTimes: '4X Bet'
    },
    multipleOfBlind: {
      twoTimes: '2X BB',
      threeTimes: '3X BB',
      fourTimes: '4X BB'
    },
    fractionOfPot: {
      oneThird: '1/3 Pot',
      oneHalf: '1/2 Pot',
      threeQuarters: '3/4 Pot',
      fullPot: 'Pot'
    }
  },
  table: {
    autoPlayerName: (position: number) => `Player ${position}`
  }
} as const
